<template>
    <div class="flex items-center">
        <label class="form-label"><slot></slot></label>
    </div>
</template>

<script>
export default {
    name: "FormLabel",
    props: {
        required: {
            type: Boolean,
            default: false
        },
    },
}
</script>

<style scoped>

</style>
